<template lang="pug">
  footer.rodape
    el-row
      el-col(:md="12" :sm="12" :xs="12")
        div.imagem-governo
        //- img.imagem-governo(:src="FOOTER.LOGO")
      el-col.posicao-icones(v-if="FOOTER.EXIBIR_REDES_SOCIAIS" :md="12" :sm="12" :xs="12")
        a.posicao-icone(:href="FOOTER.FACEBOOK" title="Curta nossa página no Facebook" target="_blank" rel="noopener")
          img(src="~@/assets/images/facebook-icon-circular.svg" class="borda_img" alt="Facebook")
        a.posicao-icone(v-if="FOOTER.TWITTER" :href="FOOTER.TWITTER" title="Siga nosso Twitter" target="_blank" rel="noopener")
          img(src="~@/assets/images/twitter-icon-circular.svg" class="borda_img" alt="Twitter")
        a.posicao-icone(:href="FOOTER.YOUTUBE" title="Assine nosso Canal no Youtube" target="_blank" rel="noopener")
          img(src="~@/assets/images/youtube-icon-circular.svg" class="borda_img" alt="Youtube")
        a.posicao-icone(:href="FOOTER.INSTAGRAM" title="Siga nossa página no Instagram" target="_blank" rel="noopener")
          img(src="~@/assets/images/instagram-icon-circular.svg" class="borda_img" alt="Instagram")
    el-row(id="hiddenslider")
      el-col.posicao-links(:md="12" :sm="24")
        a.link(href="#/publico/home") {{ FOOTER.O_SICARF }} |
        a.link(v-if="EXIBIR_COMO_BAIXAR", href="#/publico/baixar")  Como baixar |
        a.link(v-if="EXIBIR_COMO_ENVIAR", href="#/publico/enviar")  Como enviar seu pedido |
        a.link(href="#/publico/central")  Central do interessado
        a.link(v-if="EXIBIR_CONSULTA.PROCESSO", href="#/publico/geral")  | Faça sua consulta
        a.link(v-if="FOOTER.EXIBIR_INFORMACAO" href="#/publico/informacao/duvidasFrequentes")  | Informação
      //- Na seção de rodapé, por não conter nenhuma informação de redes sociais, torna-se desnecessário o endereço.
      el-col.posicao-icones(v-if="FOOTER.EXIBIR_REDES_SOCIAIS", :md="12" :sm="24")
        span {{FOOTER.ENDERECO}}
        br
        |  {{FOOTER.CEP}}
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      EXIBIR_CONSULTA: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_CONSULTA,
      FOOTER: state => state.userInterface.dadosEstado.PUBLICO.FOOTER,
      EXIBIR_COMO_BAIXAR: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_COMO_BAIXAR,
      EXIBIR_COMO_ENVIAR: state => state.userInterface.dadosEstado.PUBLICO.EXIBIR_COMO_ENVIAR
    })
  }
}
</script>

<style lang="scss" scoped>
.link {
  color: white;
  text-decoration: none;
}
.link:hover {
  text-decoration: underline;
}
.posicao-links {
  padding-top: 10px;
}
.posicao-icones {
  text-align: end;
  padding-top: 10px;
}
.posicao-icone {
  padding-left: 5px;
}
.imagem-governo {
  padding-top: 10px;
  max-height: 100px;
}
.rodape {
  flex-shrink: 0;
  height: 150px;
  background-color: #009f61;
  padding: 1px 0;
  color: white;
  font-size: 13px;
  p {
    font-size: 12px !important;
  }
}

@media (max-width: 1256px) {
  .rodape {
    width: 365px;
    padding: 1px 15px;
    height: auto;
  }
}

@media screen and (min-width: 1440px) {
  .rodape {
    padding: 0 5% 0 5%;
  }
}

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/Footer.vue